import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';

import Clickable from '@prisjakt/ui-clickable';
import { BodySmallText } from '@prisjakt/ui/text/variants';

import { BaseProps } from '../types';

type Props = Pick<BaseProps, 'category' | 'rank'>;

export const RankInCategory = (props: Props) => {
  const { rank, category } = props;

  const { renderMode, t } = useAppContext();

  return rank && category ? (
    <div>
      {t('product', 'rank.in-category', {
        categoryRank: t('product', 'rank.position', {
          rank,
        }),
        categoryLink: (
          <BodySmallText
            key="categoryLink"
            container={Clickable as any}
            containerProps={{
              to: category.pathName,
              isExternal: renderMode === 'native',
            }}
          >
            {category.name}
          </BodySmallText>
        ),
      })}
    </div>
  ) : null;
};
